class ChatAnimation extends HTMLElement {
    constructor() {
        super()

        this.selectors = {
            viewport: "[data-viewport]"
        }

        this.userEvent = false
    }

    connectedCallback() {
        this.elements = {
            viewport: this.querySelector(this.selectors.viewport)
        }

        const autoplayOptions = {
            delay: 3000,
            stopOnInteraction: false,
            stopOnFocusIn: false
        };

        const isMobile = window.innerWidth <= 768;

        const emblaOptions = {
            loop: true,
            axis: "y",
            align: "start",
            draggable: !isMobile,
            dragFree: false,
        };

        const embla = EmblaCarousel(this.elements.viewport, emblaOptions, [
            EmblaCarouselAutoplay(autoplayOptions)
        ]);

        const slides = embla.slideNodes();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    gsap.fromTo(
                        entry.target.children,
                        { yPercent: 20 },
                        {
                            yPercent: 0,
                            stagger: 0.1
                        }
                    );
                }
            });
        }, {
            threshold: 0.1,
            root: this.elements.viewport,
        });

        slides.forEach((slide) => {
            observer.observe(slide);
        });
    }
}

customElements.define("chat-animation", ChatAnimation);